{
    "component-card-search-list.empty-state.title.non-final": "<strong>Прив’яжіть цей репозиторій до програмного компонента</strong>",
    "component-card.add-chat-channel": "Додати канал чату",
    "component-card.chat-channels": "Канали чату",
    "component-card.expander.show-more-link": "Показати ще {formattedCount}"
}
